import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { Backdrop, SceneTitle, glow } from "./shared";

const PILLARS = [
  { icon: "🔒", title: "Self-hosted",     detail: "Airgapped. Open embeddings.",    c: COLORS.neonGreen },
  { icon: "🛡️", title: "RLS Isolation",   detail: "Postgres enforces tenancy.",     c: COLORS.neonBlue },
  { icon: "🌐", title: "Opt-in Web",      detail: "Query-by-query nudge.",          c: COLORS.neonCyan },
  { icon: "🔑", title: "Scoped MCP Keys", detail: "Tenant-scoped. Revocable.",      c: COLORS.neonPurple },
  { icon: "📑", title: "Every Answer Cited", detail: "Strict source mode.",         c: COLORS.neonPink },
];

export const Scene10Close: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleAp = interpolate(spring({ frame, fps, config: SPRING.snappy }), [0, 1], [0, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={COLORS.neonPurple} />

      <SceneTitle
        text="Enterprise-grade. SME-priced."
        subtitle="What nobody else is building — for the 63M they forgot."
        color={COLORS.textPrimary}
        frame={frame}
        appear={titleAp}
      />

      {/* 5 vertical rising pillars */}
      <div style={{
        position: "absolute",
        top: 280,
        left: 0, right: 0,
        display: "flex",
        justifyContent: "center",
        gap: 36,
        perspective: 1400,
        padding: "0 60px",
      }}>
        {PILLARS.map((p, i) => {
          const delay = 20 + i * 16;
          const sp = spring({ frame: frame - delay, fps, config: SPRING.bouncy });
          const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const riseY = interpolate(sp, [0, 1], [120, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const scaleY = interpolate(sp, [0, 1], [0.3, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const tilt = (i - 2) * 3;
          return (
            <div key={p.title} style={{
              width: 320,
              height: 620,
              opacity: op,
              transform: `translateY(${riseY}px) scaleY(${scaleY}) perspective(1200px) rotateY(${tilt}deg) rotateX(${Math.sin(frame * 0.02 + i) * 2}deg)`,
              transformOrigin: "bottom center",
              transformStyle: "preserve-3d",
            }}>
              <div style={{
                width: "100%", height: "100%",
                background: `linear-gradient(180deg, ${p.c}22 0%, ${p.c}11 50%, ${COLORS.bgCard}ee 100%)`,
                border: `2.5px solid ${p.c}`,
                borderRadius: 20,
                padding: "34px 24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 20,
                boxShadow: `0 0 50px ${p.c}55, 0 0 100px ${p.c}22, inset 0 0 40px ${p.c}15, 0 30px 50px rgba(0,0,0,0.5)`,
              }}>
                <div style={{ fontSize: 100 }}>{p.icon}</div>
                <div style={{
                  fontSize: 32,
                  fontFamily: FONTS.heading,
                  fontWeight: 900,
                  color: p.c,
                  textShadow: glow(p.c, true),
                  textAlign: "center",
                  letterSpacing: -0.5,
                }}>
                  {p.title}
                </div>
                <div style={{
                  fontSize: 20,
                  fontFamily: FONTS.body,
                  color: COLORS.textSecondary,
                  textAlign: "center",
                  lineHeight: 1.35,
                  marginTop: 8,
                }}>
                  {p.detail}
                </div>
                {/* Bottom light glow */}
                <div style={{
                  marginTop: "auto",
                  width: "70%",
                  height: 4,
                  borderRadius: 2,
                  background: p.c,
                  boxShadow: `0 0 30px ${p.c}, 0 0 60px ${p.c}`,
                }} />
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
